import Languages from '../../../../utils/Languages.js'
import {Order} from '../../orders/orders.types.js'
import {Reseller} from '../../resellers/resellers.types.js'
import {escapedTemplate} from '../../../utils/escapeHtml.js'
import {trackTraceLink} from '../../../../utils/trackTraceLink.js'
import {addressLines, attachment, button, card, field, intro, mailColors, mailDocument, mailDomain, multiline, stack, text} from './mailLayout.js'

const template = ({logo, message, order, address, addressIndex, completedAddresses, infoColor, info, dateHeader, displayDate, displayTime, addressHeader, color = '#ff751a', reseller, attachmentName = ''}: {
    logo: string
    message: string
    order: Order
    address: Order['addresses'][0]
    addressIndex: number
    completedAddresses?: Order['addresses']
    infoColor: string
    info: string
    dateHeader: string
    displayDate: string
    displayTime: string
    addressHeader: string
    color: string
    reseller: Reseller
    // The proof attached to the mail, e.g. Bezorgbewijs.pdf
    attachmentName?: string
}, baseUrl?: string) => {
    const moment = dateHeader || displayDate ?
        [
            text(dateHeader, {size: 12, lineHeight: 16, color: mailColors.text}),
            text([displayDate, displayTime].filter(Boolean).join('<br/>'), {size: 20, lineHeight: 28})
        ].join('') :
        ''

    return mailDocument({
        logo,
        color,
        baseUrl,
        content: stack([
            intro(multiline(message)),
            card([
                moment,
                info && text(info, {color: infoColor || mailColors.ink}),
                field(addressHeader, completedAddresses?.length > 1 ? Languages.mailAddresses.NL(completedAddresses.length) : addressLines(address)),
                field(Languages.consignor.NL, order.senderAddress?.name || order.customerAddress?.name || ''),
                order.reference && field(Languages.reference.NL, order.reference),
                field(Languages.mailBarcode.NL, order.trackTrace || ''),
                attachment(attachmentName, baseUrl),
                button(Languages.followShipment.NL, trackTraceLink(order.trackTrace, address, addressIndex, mailDomain(reseller)), color)
            ])
        ])
    })
}

export default escapedTemplate(template)
